'use client';

import { ConversionEventName } from './conversion-analytics';

type CtaId =
  | 'hire_me_nav'
  | 'hire_me_mobile_nav'
  | 'hire_me_hero_primary'
  | 'view_projects_hero_secondary'
  | 'email_hero_chip'
  | 'linkedin_hero_chip'
  | 'hire_me_dock'
  | 'quick_email_dock'
  | 'hire_me_via_email_contact'
  | 'message_on_linkedin_contact'
  | 'contact_link_click'
  | 'contact_form_submit';

function sendEvent(eventName: ConversionEventName, eventData: Record<string, unknown>) {
  const payload = JSON.stringify({ eventName, eventData });

  if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    const blob = new Blob([payload], { type: 'application/json' });
    navigator.sendBeacon('/api/analytics/collect', blob);
    return;
  }

  void fetch('/api/analytics/collect', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive: true,
  });
}

export function trackCtaClick(ctaId: CtaId, location: string, destination?: string) {
  sendEvent('cta_click', {
    cta_id: ctaId,
    location,
    destination: destination || 'n/a',
  });
}

export function trackConversion(event: 'lead_submitted' | 'lead_submit_failed', location: string) {
  sendEvent(event, { location });
}
